// Components
import TextComponent from '@/components/text/component'
import ImageTextComponent from '@/components/image-text/component'
import DropDown from '@/components/dropdown/component'
import FormatCurrency from '@/filters/currency'
import Translate from '@/filters/translate'

// The index page is the first page the user reaches when navigating to the site, residing under the root ("/") URL.
export default {
  name: 'gift-cards',
  components: { TextComponent, ImageTextComponent, DropDown },
  data () {
    return {
      adding: false,
      giftCard: 'gift-card-large',
      deliveryMethod: 'digital'
    }
  },
  mounted () {
    /* this.$store.dispatch('trackViewGiftCards', {
      list: 'gift-cards',
      giftCards: this.giftCards
    }) */
  },
  computed: {
    giftCards () {
      const ret = []
      let metadata = this.$store.getters.giftCardsMetadata
      const currency = this.$store.getters.currency.currency
      Object.entries(metadata).forEach((item) => {
        ret.push({
          name: FormatCurrency.format(item[1].prices[currency] / 100, 0),
          value: item[0],
          preSelected: item[0] === this.giftCard
        })
      })
      return ret
    },
    deliveryMethods () {
      const ret = []
      let metadata = this.$store.getters.giftCardDeliveryMethods
      Object.entries(metadata).forEach((item) => {
        ret.push({
          name: Translate.translate('giftCard' + item[1].charAt(0).toUpperCase() + item[1].slice(1)),
          value: item[1],
          preSelected: item[1] === this.deliveryMethod
        })
      })
      return ret
    }
  },
  methods: {
    setGiftCard (value) {
      this.giftCard = value.value
    },
    setDeliveryMethod (value) {
      this.deliveryMethod = value.value
    },
    addToCart () {
      if (this.adding) {
        return
      }
      this.adding = true

      let self = this
      setTimeout(function () { self.adding = false }, 1500)

      let giftCard
      let metadata = this.$store.getters.giftCardsMetadata
      Object.entries(metadata).forEach(function (item) {
        if (item[0] === self.giftCard) {
          giftCard = item[1]
        }
      })

      if (!giftCard) {
        console.log('The gift card could not be found in the meta data.')
        return
      }

      let currency = this.$store.getters.currency
      let price = giftCard.prices[currency.currency]
      if (!price) {
        // todo How to handle?
        console.log('no price found for the giftcard \'' + this.giftCard + '\' in currency \'' + currency + '\'')
        price = 0
      }

      let item = {}
      item.type = 'giftCard'
      item.product = {
        key: giftCard.key,
        name: giftCard.name,
        id: giftCard.baseID,
        category: item.type,
        url: giftCard.url,
        brand: giftCard.brand
      }
      item.options = {
        deliveryMethod: this.deliveryMethod
      }
      item.count = 1
      item.price = {
        amount: price,
        currency: this.$store.getters.currency.currency
      }

      // List and position are needed for the enhanced ecommerce
      item.list = this.list
      item.position = this.position

      // We can't add the item directly, since VueJS optimizes the clean item into a cache, which then alters all items
      // in the cart.
      this.$store.dispatch('addItem', JSON.parse(JSON.stringify(item)))
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/gift-cards/script.js